import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import EcoLoja from "./pages/EcoLoja";
import ProductDetail from "./pages/ProductDetail";
import InstagramPage from "./pages/InstagramPage";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SecretariaLanding from "./pages/SecretariaLanding";
import SecretariaEnviar from "./pages/SecretariaEnviar";
import SecretariaLogin from "./pages/SecretariaLogin";
import SecretariaPainel from "./pages/SecretariaPainel";
import SocialRequest from "./pages/SocialRequest";
import SocialSignaturePage from "./pages/SocialSignaturePage";
import SocialTrackPage from "./pages/SocialTrackPage";
import SocialLogin from "./pages/SocialLogin";
import SocialPainel from "./pages/SocialPainel";
import SocialLanding from "./pages/SocialLanding";
import PSSInscription from "./pages/PSSInscription";
import PSSPublicRegister from "./pages/PSSPublicRegister";
import PSSConvocacaoPage from "./pages/PSSConvocacaoPage";
import OuvidoriaPage from "./pages/OuvidoriaPage";
import Seguranca from "./pages/Seguranca";
import VagasList from "./pages/VagasList";
import VagaDetail from "./pages/VagaDetail";
import DispatchView from "./pages/DispatchView";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/sobre" element={<Layout><About /></Layout>} />
            <Route path="/noticias" element={<Layout><News /></Layout>} />
            <Route path="/noticias/:slug" element={<Layout><NewsDetail /></Layout>} />
            <Route path="/eco-loja" element={<Layout><EcoLoja /></Layout>} />
            <Route path="/eco-loja/:slug" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/instagram" element={<Layout><InstagramPage /></Layout>} />
            <Route path="/contato" element={<Layout><Contact /></Layout>} />
            <Route path="/seguranca" element={<Layout><Seguranca /></Layout>} />
            <Route path="/vagas" element={<Layout><VagasList /></Layout>} />
            <Route path="/vagas/:id" element={<Layout><VagaDetail /></Layout>} />
            <Route path="/secretaria" element={<Layout><SecretariaLanding /></Layout>} />
            <Route path="/secretaria/enviar" element={<Layout><SecretariaEnviar /></Layout>} />
            <Route path="/secretaria/login" element={<Layout><SecretariaLogin /></Layout>} />
            <Route path="/secretaria/painel" element={<Layout><SecretariaPainel /></Layout>} />
            <Route path="/setor-social" element={<Layout><SocialLanding /></Layout>} />
            <Route path="/setor-social/solicitar" element={<Layout><SocialRequest /></Layout>} />
            <Route path="/setor-social/assinar/:token" element={<Layout><SocialSignaturePage /></Layout>} />
            <Route path="/setor-social/acompanhar" element={<Layout><SocialTrackPage /></Layout>} />
            <Route path="/setor-social/acompanhar/:protocol" element={<Layout><SocialTrackPage /></Layout>} />
            <Route path="/setor-social/login" element={<Layout><SocialLogin /></Layout>} />
            <Route path="/setor-social/painel" element={<Layout><SocialPainel /></Layout>} />
            <Route path="/pss/inscricao/:token" element={<Layout><PSSInscription /></Layout>} />
            <Route path="/pss/auto-cadastro/:code" element={<Layout><PSSPublicRegister /></Layout>} />
            <Route path="/pss/convocacao/:token" element={<Layout><PSSConvocacaoPage /></Layout>} />
            <Route path="/canal-reclamacoes" element={<Layout><OuvidoriaPage /></Layout>} />
            <Route path="/ouvidoria" element={<Layout><OuvidoriaPage /></Layout>} />
            <Route path="/encaminhamento/:token" element={<Layout><DispatchView /></Layout>} />
            <Route path="/admin/login" element={<Layout><AdminLogin /></Layout>} />
            <Route path="/admin" element={<Layout><AdminDashboard /></Layout>} />
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
